import connect from '../axios/axios.auth';

const guiasFunction =  {
  listado: () => {
    return new Promise((resolve, reject) => {
      connect.get(`/guias`)
      .then((response) => {
        resolve(response);
      })
    })
  },
  listadoV2: (data = {}) => {
    return new Promise((resolve, reject) => {
      connect.post(`/guias/v2/`, data)
      .then((response) => {
        resolve(response);
      })
    })
  },
  entrega: (data) => {
    return new Promise((resolve, reject) => {
      connect.post(`/guias/entrega`, data)
      .then((response) => {
        resolve(response);
      })
    })
  },
  filtro: (data) => {
    return new Promise((resolve, reject) => {
      connect.post(`/guias/v2/`, data)
      .then((response) => {
        resolve(response);
      })
    })
  },
  listadoEstadosPorGuia: (id) => {
    return new Promise((resolve, reject) => {
      connect.get(`/guias/estados/${id}/`)
      .then((response) => {
        resolve(response);
      })
    })
  }
}

export default guiasFunction;